import { IAlertConfig } from '../../../../models/bootstrap/Alert' 
import { BusinessArea } from '../../../../services/AuthService';


class AgencyCommentModalController{

    isOfficeUser: boolean = false;

    showMessageText: boolean = false
    alerts: IAlertConfig[] = []

    static $inject = ['$scope', '$uibModalInstance', 'Agency', 'agencyComment', 'agencyId', 'Auth', '$timeout']
    constructor(private $scope, private $uibModalInstance, private Agency, private agencyComment, private agencyId, Auth, private $timeout) {
        this.isOfficeUser = Auth.user.isOfficer;
        this.agencyComment.agencyId = agencyId;
    }

    validate() {
        this.$scope.$broadcast('submitted', true)
        return this.agencyComment.$validation();
    }

    cancel() {
        this.$uibModalInstance.dismiss('cancel')
    }

    save() {
        if (!this.validate()) {
            return
        }

        this.alerts = [];

        this.Agency.saveAgencyComment({ agencyId: this.agencyId }, this.agencyComment)
            .$promise.then(() => {
                this.$uibModalInstance.close()
            },
                () => {

                    this.alerts.push({
                        type: 'danger',
                        msg: 'We are sorry but your form could not be saved. Please try again in 5 minutes. <br /> If this problem continues, please contact us at: <a target= "_blank" href= "mailto:support@aupairamerica.co.uk" > support@aupairamerica.co.uk</a>',
                        dismissOnTimeout: 5000
                    })
                    this.showMessageText = true;
                    this.$timeout(() => { this.showMessageText = false; }, 5000);
                });

    }
}

angular
    .module('app')
    .controller('AgencyCommentModalController', AgencyCommentModalController)